import * as React from 'react';

interface TimerComponentProps {
  interval: number;
  callback: () => void;
}

class TimerComponent extends React.Component<TimerComponentProps> {
  private interval: any;

  public componentDidMount() {
    this.props.callback();
    this.interval = setInterval(this.props.callback, this.props.interval);
  }

  public componentDidCatch() {
    clearInterval(this.interval);
  }

  public componentWillUnmount() {
    clearInterval(this.interval);
  }

  public render() {
    return this.props.children;
  }
}

export const Timer = TimerComponent;
